import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { Theme, useTheme } from '@material-ui/core/styles';

function getColor(type: string, theme: Theme): string {
  switch (type) {
    case 'succeeded':
    case 'healthy':
    case 'synced':
      return theme.palette.success.main;
    case 'failed':
    case 'degraded':
      return theme.palette.error.main;
    case 'pending':
    case 'progressing':
    case 'outofsync':
      return theme.palette.warning.main;
    case 'suspended':
      return theme.palette.info.main;
    case 'missing':
    case 'unknown':
    default:
      return theme.palette.grey[500];
  }
}

export const StatusIndicator = ({
  type,
  label,
}: {
  type: string;
  label?: string;
}) => {
  const theme = useTheme();
  const color = getColor(type, theme);
  return (
    <Box display="inline-flex" alignItems="center" gridGap={6}>
      <Box
        component="span"
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: color,
          flexShrink: 0,
        }}
      />
      <Typography variant="body2" style={{ lineHeight: '23px' }}>
        {label || type}
      </Typography>
    </Box>
  );
};
